import React from "react";
import { Studio } from "../App";

// KitRoute simply renders the original Studio page (non-sticky nav inside Studio)
export default function KitRoute() {
  return <Studio />;
}